module.exports = __webpack_public_path__ + "static/media/101881876_247849379833376_1124300297812836352_n.3a85b214.jpg";